import { Injectable } from '@angular/core';
import { Login } from '../models/login';
import { HTTPClientService } from './httpclient.service';
import { SessionFactory } from '../caches/session.factory';
import { Fldr } from '../models/datapoint/fldr';
import { DIMsgObj } from '../models/dimsgobj';
import { FilterObject } from '../models/filter/filter.object';
import { RepConn } from '../models/datapoint/repconn';
import { DataObject } from '../models/domain/dataobject';
import { Observable, of } from 'rxjs';
import { ValidateObj } from '../models/objs/validateObj';
import { ListFactory } from '../caches/list.factory';
import { Usr } from '../models/usr';
import { Design } from '../models/domain/design';
import { ImportJSON } from '../models/importJSON/importJSON';
import { DownloadFile } from '../models/stream/jobs/downloadfile';
import { Obj_Db_Property } from '../models/datapoint/obj_db_property';
import { Ops_Poll } from '../models/beans/ops_polls';
import { SQLOverride } from '../models/stream/jobs/sqloverride';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiConnector, catalogFromApi, catalogFromJars, ConnectorCatalogEntry } from '../databases/dbversions/connector-catalog';


@Injectable({
  providedIn: "root",
})
export class ServiceManager {
  private sessionFactory: SessionFactory;
  private listFactory: ListFactory;
  apiUrl: string;

  constructor(
    private httpClientService: HTTPClientService,
    private http: HttpClient,
  ) {
    this.sessionFactory = SessionFactory.getInstance();
    this.listFactory = ListFactory.getInstance();
    this.setApiUrl();
  }

  private setApiUrl(): void {
    const { protocol, hostname } = window.location;
    this.apiUrl = `${protocol}//${hostname}:9090`;
  }

  generateGlossaryDescription(
    attributes: { attrNm: string }[],
    login_Id: string,
    fldr_Id: number,
    db_type_nm: any,
    table_nm: any,
  ): Observable<any> {
    const url = `${this.apiUrl}/bussinessGlossary/getAttributesDescription/${login_Id}/${fldr_Id}/${db_type_nm}/${table_nm}`;
    return this.http.post(url, attributes);
  }
  // //for server
  //private apiUrl = 'http://40.76.233.123:9090';
  //private apiUrl = 'https://demo.purplecube.ai:9090';
  //   private apiUrl = 'http://4.227.154.243:9090';
  // generateGlossaryDescription(attributes: { attrNm: string }[], login_Id : string, fldr_Id:number, db_type_nm: any, table_nm:any,  useRemote: boolean): Observable<any> {
  //   const apiUrl = useRemote
  //   ? 'https://demo.purplecube.ai:9090'
  //   : 'http://40.76.233.123:9090';
  //   const url = `${apiUrl}/bussinessGlossary/getAttributesDescription`+ '/' + login_Id + '/' + fldr_Id + '/' + db_type_nm  + '/' + table_nm;
  //   return  this.http.post(url, attributes);
  // }

  // for local, login_Id: string, fldr_Id: number, db_type_nm: string
  // generateGlossaryDescription(attributes: { attrNm: string }[],login_Id : string, fldr_Id:number, db_type_nm: any, table_nm:any ): Observable<any> {
  //   //     //const url = `${this.apiUrl}/bussinessGlossary/getAttributesDescription`+ '/' + login_Id + '/' + fldr_Id;
  //  // const url = 'http://localhost:9090/bussinessGlossary/getAttributesDescription'+'/' + login_Id + '/' + fldr_Id + '/' + db_type_nm  + '/' + table_nm;
  //   const url = 'http://localhost:9090/bussinessGlossary/getAttributesDescription'
  //   return this.http.post(url, attributes);
  // }
  // private apiUrl = 'localhost:9090/bussinessGlossary/startScript';
  //  private apiurl = 'http://4.227.154.243:9090';
  // startScript(): Observable<any> {
  //   const url = `${this.apiUrl}/bussinessGlossary/startScript`
  //   return this.http.get(url);
  // }
  startScript(): Observable<any> {
    return this.httpClientService.get("/service/studio/startScript");
  }
  // startScript(): Observable<any> {
  //   const url = 'localhost:9090/bussinessGlossary/startScript'
  //   return this.http.post(url, {});
  // }
  session(showBusyCursor: boolean = false): Observable<DIMsgObj> {
    return this.httpClientService.get("/service/check/session", showBusyCursor);
  }

  signIn(login: Login, showBusyCursor: boolean = false): Observable<DIMsgObj> {
    return this.httpClientService.post("/service/login", login, showBusyCursor);
  }

  getFldr(
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/getFldr/" + fldr_Id,
      showBusyCursor,
    );
  }

  datatypesxml(
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/datatypesxml/" + fldr_Id,
      showBusyCursor,
    );
  }

  loadFldrs(showBusyCursor: boolean = false): void {
    if (this.sessionFactory.fldrs.length == 0) {
      this.getFldrs(this.sessionFactory.usr).subscribe((diMsgObj) => {
        for (let i: number = 0; i < diMsgObj.retMsgObject.fldrs.length; i++) {
          let fldr: Fldr = Fldr.parse(diMsgObj.retMsgObject.fldrs[i]);
          fldr.imageUrl =
            "assets/" + fldr.imageUrl.slice(4, fldr.imageUrl.length);
          this.sessionFactory.fldrs.push(fldr);
        }
        if (this.listFactory.fldrListObjects.length == 0)
          this.listFactory.fldrListObjects = this.sessionFactory.fldrs;
      });
    }
  }

  changePassword(object: any): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/admin/user/changepassword",
      object,
      true,
    );
  }

    resetPassword(object: any): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/admin/users/reset-password",
      object,
      true,
    );
  }

  databaseslist(
    fldr_Id: number,
    startLimit: number,
    endLimit: number,
    filter: string,
    obj_Cd: string,
    designCode: any,
    isStreaming: string,
    operation_Cd: string,
    dbTyp_Ids: Array<number>,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/databaseslist/" +
        fldr_Id +
        "/" +
        startLimit +
        "/" +
        endLimit +
        "/" +
        filter +
        "/" +
        obj_Cd +
        "/" +
        designCode +
        "/" +
        isStreaming +
        "/" +
        operation_Cd,
      dbTyp_Ids,
      showBusyCursor,
      undefined,
    );
  }

  /**
   * @api
   */
  recentOpenedObjects(
    login_Id: string,
    module_Cd: string,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/recentOpenedObjects/" + login_Id + "/" + module_Cd,
    );
  }

  checkSSOLogin(): Observable<DIMsgObj> {
    return this.httpClientService.get("/service/checkssologin");
  }

  globalSearch(
    searchText: string,
    fldr_Id: number,
    showBusyCursor: boolean,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/search/" + searchText + "/" + fldr_Id,
      showBusyCursor,
    );
  }

  getFldrs(
    usr: Usr,
    startLimit: number = 0,
    endLimit: number = -1,
    filter: string = "*",
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/didashboard/" + startLimit + "/" + endLimit + "/" + filter,
      usr,
      showBusyCursor,
    );
  }

  updateFldrObject(
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/getFldr/" + fldr_Id,
      showBusyCursor,
    );
  }

  about(
    host: string,
    port: string,
    showBusyCursor: boolean,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/about/" + host + "/" + port,
      showBusyCursor,
    );
  }

  getDatasets(repconn, fldr_Id: number, project_Id) {
    return this.httpClientService.post(
      "../../../service/studio/getDatasetsByProject/" +
        fldr_Id +
        "/" +
        project_Id,
      repconn,
      true,
    );
  }

  multiSelect(
    fldr_Id: number,
    diMsgObject: DIMsgObj,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/multiSelect/" + fldr_Id,
      diMsgObject,
      showBusyCursor,
    );
  }

  multiSelectObjects(
    fldr_Id: number,
    currentFldr_Id: number,
    diMsgObj: DIMsgObj,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    var skipCodes = ["ESM00013", "ESM00004", "ESM00167", "ESM00530"];
    return this.httpClientService.post(
      "/service/studio/multiSelectObjects/" + fldr_Id + "/" + currentFldr_Id,
      diMsgObj,
      showBusyCursor,
      false,
      skipCodes,
    );
  }

  projectdashboard(
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    let offSet: number = new Date().getTimezoneOffset() * 60;
    let skipCodes: Array<string> = ["ESM00013", "ESM00041"];

    return this.httpClientService.get(
      "../service/projectdashboard/" + fldr_Id + "/" + offSet,
      showBusyCursor,
      skipCodes,
    );
  }

  newProjectDashboard(fldr_Id: number): Observable<DIMsgObj> {
    let offSet: number = new Date().getTimezoneOffset() * 60;
    let skipCodes: Array<string> = ["ESM00013", "ESM00041"];

    return this.httpClientService.get(
      "/service/newprojectdashboard/" + fldr_Id + "/" + offSet + skipCodes,
    );
  }

  selectAdminObject(
    obj_Id: number,
    obj_Cd: string,
    reusableFlag: string,
    org_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/admin/selectObject/" +
        obj_Id +
        "/" +
        obj_Cd +
        "/" +
        reusableFlag +
        "/" +
        org_Id,
      showBusyCursor,
    );
  }

  logout(loginId: string): Observable<DIMsgObj> {
    return this.httpClientService.get("/service/logout/" + loginId);
  }

  getList(fldr_Id: number, obj_Cd: string): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/objpool/" +
        fldr_Id +
        "/" +
        obj_Cd +
        "/-1/1/100/N/N/-1/*/false/-1/N",
    );
  }

  ddl(dObj_Ids: Array<number>): Observable<DIMsgObj> {
    return this.httpClientService.post("/service/studio/ddl", dObj_Ids, true);
  }

  getSystemParams(
    obj_Cd: string,
    obj_Id: number,
    object: any,
    isLink: boolean,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/params_xml/" + obj_Cd + "/" + obj_Id + "/" + isLink,
      object,
      showBusyCursor,
    );
  }

  getDatabaseFunctions(
    dbTyp_Id: number,
    obj_Cd: string,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.get(
      "/service/studio/functions/" + dbTyp_Id + "/" + obj_Cd,
      showBusyCursor,
    );
  }

  getPrepostsql(
    dobj_Id: number,
    fldr_Id: number,
    conn_Id: number,
    conn_Db_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/prepostsql/" +
        dobj_Id +
        "/" +
        fldr_Id +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id,
      showBusyCursor,
    );
  }

  getProcesscommand(
    fldr_Id,
    layer_Id,
    obj_Id,
    obj_Cd,
    reRunObj_Id,
    cmd_Cd,
    diMsgObjectEmpty,
  ) {
    let skipCodes = ["ESM00041"];
    return this.httpClientService.post(
      "/service/studio/processcommand/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        obj_Id +
        "/" +
        obj_Cd +
        "/" +
        reRunObj_Id +
        "/" +
        cmd_Cd,
      diMsgObjectEmpty,
      true,
      false,
      skipCodes,
    );
  }

  processOverrideSQL(
    sQLOverride: SQLOverride,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/processOverrideSQL",
      sQLOverride,
      showBusyCursor,
    );
  }

  getSSOType() {
    return this.httpClientService.get("/service/SSOType");
  }

  getVersion() {
    return this.httpClientService.get("/service/version");
  }

  selectTransformObjects(object, parent_Id, fldr_Id, showBusyCursor) {
    return this.httpClientService.post(
      "/service/studio/selectTransformObjects/" + parent_Id + "/" + fldr_Id,
      object,
      showBusyCursor,
    );
  }

  getCopyEmptyObj() {
    return this.httpClientService.get("/service/studio/copy/empty");
  }

  /**
   * API call:
   * @param login_Id
   * @param module_Cd
   *
   * To get `Fldr` object, which the current user has been accessed recently project.
   *
   * DOC: project dropdown. 2nd and 3rd points.
   */
  recentOpenedFolder(
    login_Id: string,
    module_Cd: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/recentOpenedFolder/" + login_Id + "/" + module_Cd,
      showBusyCursor,
    );
  }

  getForgotPassword(
    mail_Id: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/forgotpassword/" + mail_Id,
      showBusyCursor,
    );
  }

  //Verify OTP
    verifyOTP(otpObj : any): Observable<DIMsgObj> {
    return this.httpClientService.post("/service/verify-otp", otpObj , true);
  }

  filterSearch(
    isFilter: boolean,
    streammingFlg: string,
    filterObject: FilterObject,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/filterSerach/" + isFilter + "/" + streammingFlg,
      filterObject,
      showBusyCursor,
    );
  }

  getSensitiveProjectParameters(fldr_Id: number = 0) {
    return this.httpClientService.get(
      "/service/studio/getSensitiveProjectParameters/" + fldr_Id,
    );
  }

  getDbVersions() {
    return this.httpClientService.get("/service/studio/jars_xml");
  }

  unlockOnFldr(fldr_Id: number): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/unlockOnFldr/" + fldr_Id,
    );
  }

  RecentlyOpenedObjects(login_Id: string) {
    return this.httpClientService.get(
      "/service/recentOpenedObjects/" + login_Id,
    );
  }

  parseImportJSON(diMsgObj: DIMsgObj): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/parseImportJSON/",
      diMsgObj,
    );
  }

  getLoadMoreConnDbs(
    fldr_Id,
    reusableFlag,
    dbTyp_Id,
    startLimit,
    endLimit,
    code,
    filter,
    localFlag,
    layer_Id,
    sqlobj_cd,
    dbTyp_Ids,
    showBusyCursor,
    streammingFlg,
  ) {
    let skipCodes = ["ESM00041"];
    return this.httpClientService.post(
      "/service/studio/dataobjectcreationpopup/" +
        fldr_Id +
        "/" +
        reusableFlag +
        "/" +
        dbTyp_Id +
        "/" +
        startLimit +
        "/" +
        endLimit +
        "/" +
        code +
        "/" +
        filter +
        "/" +
        localFlag +
        "/" +
        layer_Id +
        "/" +
        sqlobj_cd +
        "/" +
        streammingFlg,
      dbTyp_Ids,
      showBusyCursor,
      undefined,
      skipCodes,
      true,
    );
  }

  getReusableProjects(fldr_Id) {
    if (fldr_Id == undefined) fldr_Id = -1;
    return this.httpClientService.get(
      "/service/reusableprojects/" + fldr_Id,
      true,
    );
  }

  getAvailableName(
    fldr_Id: number,
    obj_Cd: string,
    conn_Id: number,
    conn_Db_Id: number,
    aliasNm: string,
    dbTyp_Id: number,
    objNm_Lock_Id: number,
    streamingFlag: string,
    layer_Id: number,
    obj_Nm: string,
    cpyAsOtherFlag: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    if (streamingFlag == undefined) streamingFlag = "N";
    if (layer_Id == undefined) layer_Id = -1;
    let skipCodes = ["ESM00041"];
    let diMsgObject = new DIMsgObj();
    diMsgObject.retMsgObject = obj_Nm;
    return this.httpClientService.post(
      "/service/studio/getAvailableName/" +
        fldr_Id +
        "/" +
        obj_Cd +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        aliasNm +
        "/" +
        dbTyp_Id +
        "/" +
        objNm_Lock_Id +
        "/" +
        streamingFlag +
        "/" +
        layer_Id +
        "/undefined",
      diMsgObject,
      showBusyCursor,
    );
  }

  updateDatabases(
    fldr_Id: number,
    startLimit: number,
    endLimit: number,
    filter: string,
    obj_Cd: string,
    designCode: boolean,
    streamingFlg: string,
    operation_Cd: string,
    dbType_Ids,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    let skipCodes = ["ESM00041"];
    return this.httpClientService.post(
      "/service/studio/databaseslist/" +
        fldr_Id +
        "/" +
        startLimit +
        "/" +
        endLimit +
        "/" +
        filter +
        "/" +
        obj_Cd +
        "/" +
        designCode +
        "/" +
        streamingFlg +
        "/" +
        operation_Cd,
      dbType_Ids,
      showBusyCursor,
      undefined,
      skipCodes,
    );
  }

  updateAvroProperties(
    conn_Id,
    dbTyp_Id,
    obj_Id,
    dxMp_Inst_Id,
    dxFlow_Id,
    el_Type,
    properties,
  ) {
    return this.httpClientService.post(
      "/service/studio/updateAvroProperties/" +
        conn_Id +
        "/" +
        dbTyp_Id +
        "/" +
        obj_Id +
        "/" +
        dxMp_Inst_Id +
        "/" +
        dxFlow_Id +
        "/" +
        el_Type,
      properties,
      true,
    );
  }

  updateDFSProperties(
    conn_Id,
    dbTyp_Id,
    obj_Id,
    dxMp_Inst_Id,
    dxFlow_Id,
    el_Type,
    properties,
  ) {
    return this.httpClientService.post(
      "/service/studio/updateDFSProperties/" +
        conn_Id +
        "/" +
        dbTyp_Id +
        "/" +
        obj_Id +
        "/" +
        dxMp_Inst_Id +
        "/" +
        dxFlow_Id +
        "/" +
        el_Type,
      properties,
      true,
    );
  }

  copyJobWrapper(fldr_Id: number, object: any) {
    return this.httpClientService.post(
      "/service/studio/copyJob/" + fldr_Id,
      object,
      true,
    );
  }

  copyStreamCommentWrapper(fldr_Id: number, object: any) {
    return this.httpClientService.post(
      "/service/studio/copystreamcomment/" + fldr_Id,
      object,
      true,
    );
  }

  createMultipleJobs_new(
    objectWrapper,
    obj_Cd,
    fldr_Id,
    layer_Id,
    parent_Id,
    dbTyp_Id,
    obj_Nm,
    aliasNm,
    lnk_Obj_Ids,
    transientFlag,
    conn_Id,
    conn_Db_Id,
    streamingFlg,
    type,
    objNm_Lock_Id,
    performanceflg,
    selectedDesigns,
    diMsgObject,
    showBusyCursor: boolean = true,
  ) {
    if (layer_Id == undefined) layer_Id = -1;
    if (lnk_Obj_Ids.length == 0) lnk_Obj_Ids = -1;
    if (transientFlag == undefined) transientFlag = "N";
    if (streamingFlg == undefined) streamingFlg = "N";
    if (objNm_Lock_Id == undefined) objNm_Lock_Id = -1;

    if (conn_Id == undefined || conn_Id == "") {
      conn_Id = -1;
    }

    if (conn_Db_Id == undefined || conn_Db_Id == "") {
      if (conn_Db_Id != 0) {
        conn_Db_Id = -1;
      }
    }

    let skipCodes = ["ESM00041"];

    return this.httpClientService.post(
      "/service/studio/createMultipleJobs/new/" +
        obj_Cd +
        "/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        parent_Id +
        "/" +
        dbTyp_Id +
        "/" +
        obj_Nm +
        "/" +
        aliasNm +
        "/" +
        transientFlag +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        streamingFlg +
        "/" +
        type +
        "/" +
        objNm_Lock_Id +
        "/" +
        performanceflg,
      diMsgObject,
      showBusyCursor,
    );
  }

  openListObjects(
    fldr_Id: number,
    diMsgObject: DIMsgObj,
    showBusyCursor: boolean = false,
  ) {
    // currentFldr_Id
    var skipCodes = ["ESM00013", "ESM00004", "ESM00167", "ESM00530"];
    return this.httpClientService.post(
      "/service/studio/multiSelectObjects/" + fldr_Id + "/" + fldr_Id,
      diMsgObject,
      showBusyCursor,
      false,
      skipCodes,
    );
  }

  validateObjName(
    fldr_Id: number,
    objName: string,
    conn_Id: number,
    conn_Db_Id: number,
    aliasNm: string,
    obj_Cd: string,
    obj_Id: number,
    dbTyp_Id: number,
    streamingFlag: string,
    layer_Id: number,
  ): Observable<DIMsgObj> {
    let diMsgObj: DIMsgObj = new DIMsgObj();
    diMsgObj.persistVal["objName"] = objName;
    diMsgObj.persistVal["aliasNm"] = aliasNm;

    let skipCodes: Array<string> = [
      "ESM00013",
      "ESM00004",
      "ESM00167",
      "ESM00530",
    ];
    return this.httpClientService.post(
      "/service/studio/validateObjName/" +
        fldr_Id +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        obj_Cd +
        "/" +
        obj_Id +
        "/" +
        dbTyp_Id +
        "/" +
        streamingFlag +
        "/" +
        layer_Id,
      diMsgObj,
      true,
    );
  }

  deletenmlock(
    fldr_Id: number,
    obj_Ids: Array<number>,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/deletenmlock/" + fldr_Id,
      obj_Ids,
      showBusyCursor,
    );
  }

  saveObject(diMsgObject: DIMsgObj) {
    return this.httpClientService.post(
      "/service/studio/object/save",
      diMsgObject,
      true,
      false,
    );
  }

  saveRepFolderObject(
    diMsgObject: DIMsgObj,
    obj_Cd: string,
    handleError: boolean,
  ) {
    return this.httpClientService.post(
      "/service/admin/saveObject/" + obj_Cd,
      diMsgObject,
      true,
      handleError,
    );
  }
  saveProjectParam(
    diMsgObject: DIMsgObj,
    fldr_Id: number,
    handleError: boolean,
  ) {
    return this.httpClientService.post(
      "/service/admin/saveProjectParam/" + fldr_Id,
      diMsgObject,
      true,
      handleError,
    );
  }

  export(
    obj_Cd: string,
    fldr_Id: number,
    diMsgObject: DIMsgObj,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/export/" + obj_Cd + "/" + fldr_Id,
      diMsgObject,
      showBusyCursor,
    );
  }

  postExportObject(diMsgObject: any) {
    return this.httpClientService.post(
      "/service/studio/exportFilterObject",
      diMsgObject,
    );
  }

  getAdminLoadMoreObjects(
    org_Id: number,
    obj_Cd: string,
    startLimit: number,
    endLimit: number,
    filter,
    propertyType_cd,
    showBusyCursor,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/admin/gridObjects/" +
        org_Id +
        "/" +
        obj_Cd +
        "/" +
        startLimit +
        "/" +
        endLimit +
        "/" +
        filter +
        "/" +
        propertyType_cd,
      showBusyCursor,
      undefined,
      false,
    );
  }

  getLayers(
    fldr_Id: number,
    filter: string,
    showBusyCursor: boolean = true,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/layers2/" + fldr_Id + "/" + filter,
      showBusyCursor,
    );
  }

  getDashboardData(startLimit, endLimit, filter, objects) {
    return this.httpClientService.post(
      "/service/didashboard/" + startLimit + "/" + endLimit + "/" + filter,
      objects,
    );
  }

  importJSON(
    importJSONData: ImportJSON,
    showBusyCursor: boolean = true,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/importJSON",
      importJSONData,
      showBusyCursor,
    );
  }

  importDefault(
    importJSONData: ImportJSON,
    showBusyCursor: boolean = true,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/importDefault",
      importJSONData,
      showBusyCursor,
    );
  }

  dependencies(
    obj_Id: number,
    obj_Cd: string,
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/dependencies/" + obj_Id + "/" + obj_Cd + "/" + fldr_Id,
      showBusyCursor,
    );
  }

  dependencyObjects(
    obj_Id: number,
    obj_Cd: string,
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    let skipCodes = ["ESM00055"];
    return this.httpClientService.get(
      "/service/studio/dependencyObjects/" +
        obj_Id +
        "/" +
        obj_Cd +
        "/" +
        fldr_Id,
      showBusyCursor,
      skipCodes,
    );
  }

  //  Test Repconn call
  testConnection(connInfo: RepConn, fldr_Id: number): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/testconn/" + fldr_Id,
      connInfo,
      true,
    );
  }

  copyObjects(
    fldr_Id: number,
    obj_Cd: string,
    localFlag: string,
    performanceFlg: any,
    diMsgObj: DIMsgObj,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/copyObjects/" +
        fldr_Id +
        "/" +
        obj_Cd +
        "/" +
        localFlag +
        "/" +
        performanceFlg,
      diMsgObj,
      showBusyCursor,
    );
  }

  //Create copy design
  createCopyPerformace(
    fldr_Id: number,
    obj_Cd: string,
    localFlg: string,
    copyObjectIds: DIMsgObj,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/createcopy/" + fldr_Id + "/" + obj_Cd + "/" + localFlg,
      copyObjectIds,
      showBusyCursor,
    );
  }

  // Get Agents List
  getAgentsBasedOn_Fldr(fldr_Id: number): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/getAgentsBasedOn_Fldr/" + fldr_Id,
      true,
    );
  }

  admin_Owners(
    fldr_Id: number,
    startLimit: number,
    endLimit: number,
    filter: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/admin/owners/" +
        fldr_Id +
        "/" +
        startLimit +
        "/" +
        endLimit +
        "/" +
        filter,
      showBusyCursor,
    );
  }

  // Get Group Names
  postFilterObject(
    isFilter,
    streammingFlg,
    diMsgObjectEmpty,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/filterSerach/" + isFilter + "/" + streammingFlg,
      diMsgObjectEmpty,
      showBusyCursor,
      undefined,
    );
  }

  //getJars_Xml
  /**
   * Connector types, distributions and versions for the Data Point screen.
   * - purplecube-etl: only GET /api/v1/connectors (no jars.xml, no versions).
   * - purplecube-backend: that API does not exist (404), so everything comes from jars.xml
   *   (GET /service/studio/jars_xml).
   * Any other API failure yields an empty catalog so the Data Point page still opens.
   */
  getDistrColl(): Observable<Array<ConnectorCatalogEntry>> {
    return this.httpClientService.getRaw("/api/v1/connectors", true, false).pipe(
      map(result => catalogFromApi(Array.isArray(result) ? (result as Array<ApiConnector>) : [])),
      catchError(err => {
        if (err && err.status == 404) {
          return this.httpClientService.get("/service/studio/jars_xml", true).pipe(
            map(diMsgObj => catalogFromJars(diMsgObj && diMsgObj.retMsgObject ? diMsgObj.retMsgObject.jConns : null)),
            catchError(() => of(new Array<ConnectorCatalogEntry>()))
          );
        }
        console.error('Failed to load connectors from /api/v1/connectors', err);
        return of(new Array<ConnectorCatalogEntry>());
      })
    );
  }

  //  Delete Objects
  deleteObjects(
    fldr_Id: number,
    obj_Cd: string,
    diMsgObj: DIMsgObj,
    layer_Id: number,
    isPerformance: boolean,
    _focebleDeleteDp: boolean,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/selectObjects/" +
        fldr_Id +
        "/" +
        obj_Cd +
        "/" +
        layer_Id +
        "/" +
        isPerformance +
        "/" +
        _focebleDeleteDp,
      diMsgObj,
      true,
    );
  }

  // Loadmoreobjects in Repconn List
  objpool(
    fldr_Id: number,
    obj_Cd: string,
    obj_Id: number,
    startLimit: number,
    endLimit: number,
    reusableFlg: string,
    fldr_ReusableFlg: string,
    dbTyp_Id: number,
    filter: string,
    isExpressionEditor: boolean,
    layer_Id: number,
    streamingFlg: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/objpool/" +
        fldr_Id +
        "/" +
        obj_Cd +
        "/" +
        obj_Id +
        "/" +
        startLimit +
        "/" +
        endLimit +
        "/" +
        reusableFlg +
        "/" +
        fldr_ReusableFlg +
        "/" +
        dbTyp_Id +
        "/" +
        filter +
        "/" +
        isExpressionEditor +
        "/" +
        layer_Id +
        "/" +
        streamingFlg,
      showBusyCursor,
    );
  }

  dataobjectcreationpopup(
    fldr_Id: number,
    reusableFlag: string,
    dbTyp_Id: number,
    startLimit: number,
    endLimit: number,
    code: string,
    filter: string,
    localFlag: string,
    layer_Id: number,
    sqlobj_cd: string,
    dbTyp_Ids: Array<number>,
    showBusyCursor: boolean = false,
    streammingFlg: string,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/dataobjectcreationpopup/" +
        fldr_Id +
        "/" +
        reusableFlag +
        "/" +
        dbTyp_Id +
        "/" +
        startLimit +
        "/" +
        endLimit +
        "/" +
        code +
        "/" +
        filter +
        "/" +
        localFlag +
        "/" +
        layer_Id +
        "/" +
        sqlobj_cd +
        "/" +
        streammingFlg,
      dbTyp_Ids,
      showBusyCursor,
      undefined,
    );
  }

  dmwRepConnGridObjects(
    fldr_Id,
    startLimit,
    endLimit,
    dbTyp_Id,
    filter,
    dxMp_Id,
    obj_Cd,
    object,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "../../../service/studio/multidatapointdmw/" +
        fldr_Id +
        "/" +
        startLimit +
        "/" +
        endLimit +
        "/" +
        dbTyp_Id +
        "/" +
        filter +
        "/" +
        dxMp_Id +
        "/" +
        obj_Cd,
      object,
      true,
    );
  }

  ntvDataPointChange(fldr_Id, conn_Id, design) {
    return this.httpClientService.post(
      "/service/studio/ntvDataPointChange/" + fldr_Id + "/" + conn_Id,
      design,
      true,
    );
  }

  createNewObject(
    objectWrapper,
    obj_Cd: string,
    fldr_Id: number,
    layer_Id: number,
    parent_Id: number,
    dbTyp_Id: number,
    obj_Nm: string,
    aliasNm: string,
    lnk_Obj_Id: number,
    transientFlag: string,
    conn_Id: number,
    conn_Db_Id: number,
    streamingFlg: string,
    type: any,
    objNm_Lock_Id: number,
    performanceFlag: boolean,
    dataConnectService_Id: number,
    dataConnectService_Nm: string,
    showBusyCursor: boolean,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/object/new/" +
        obj_Cd +
        "/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        parent_Id +
        "/" +
        dbTyp_Id +
        "/" +
        obj_Nm +
        "/" +
        aliasNm +
        "/" +
        lnk_Obj_Id +
        "/" +
        transientFlag +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        streamingFlg +
        "/" +
        type +
        "/" +
        objNm_Lock_Id +
        "/" +
        performanceFlag +
        "/" +
        dataConnectService_Id +
        "/" +
        dataConnectService_Nm,
      objectWrapper,
      showBusyCursor,
    );
  }

  object_new(
    object: any,
    obj_Cd: string,
    fldr_Id: number,
    layer_Id: number,
    parent_Id: number,
    dbTyp_Id: number,
    obj_Nm: string,
    aliasNm: string,
    lnk_Obj_Id: number,
    transientFlag: string,
    conn_Id: number,
    conn_Db_Id: number,
    streamingFlg: string,
    type: boolean | string,
    objNm_Lock_Id: number,
    performanceflg: boolean,
    dataConnectService_Id: number,
    dataConnectService_Nm: string,
    showBusyCursor: boolean = true,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/object/new/" +
        obj_Cd +
        "/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        parent_Id +
        "/" +
        dbTyp_Id +
        "/" +
        obj_Nm +
        "/" +
        aliasNm +
        "/" +
        lnk_Obj_Id +
        "/" +
        transientFlag +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        streamingFlg +
        "/" +
        type +
        "/" +
        objNm_Lock_Id +
        "/" +
        performanceflg +
        "/" +
        dataConnectService_Id +
        "/" +
        dataConnectService_Nm,
      object,
      showBusyCursor,
    );
  }

  // Lock and Unlock Objects

  unlock(fldr_Id: number, diMsgObjectEmpty: DIMsgObj): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/unlock/" + fldr_Id,
      diMsgObjectEmpty,
      true,
    );
  }

  // Get Import Data Objects
  importTableNms(
    conn_Id: number,
    conn_Db_Id: number,
    filterObject: any,
    aliasNm: string,
    ignoreSynonyms: string,
    showBusyCursor: boolean = true,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/importTableNms/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        aliasNm +
        "/" +
        ignoreSynonyms,
      filterObject,
      showBusyCursor,
    );
  }

  // getPlainObjects("app/json/collections.json").then(function(diMsgObject){
  //   defer.resolve(diMsgObject);

  getPlainObjects(showBusyCursor: boolean = false) {
    // return this.httpClientService.post("app/json/collections.json" + showBusyCursor)
  }

  // Move the data object to other data point
  moveToOtherObject(
    fldr_Id,
    conn_Id,
    conn_Db_Id,
    dObj_list,
    showBusyCusor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/dataobject/movetoother/" +
        fldr_Id +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id,
      dObj_list,
      showBusyCusor,
    );
  }

  carryFrwdAttributes(
    obj_Id: number,
    dxMp_Id: number,
    readFlag: boolean,
    tabCode: string,
    srt_Order: number,
    obj_Cd: string,
    isDist: boolean,
  ) {
    return this.httpClientService.get(
      "/service/studio/carryFrwd/" +
        obj_Id +
        "/" +
        dxMp_Id +
        "/" +
        readFlag +
        "/" +
        tabCode +
        "/" +
        srt_Order +
        "/" +
        obj_Cd +
        "/" +
        isDist,
      true,
    );
  }

  getProjectParams(fldr_Id: number): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/projectParameters/" + fldr_Id,
      true,
    );
  }

  getCarryForwardAttributes(
    obj_Id: number,
    dxMp_Id: number,
    readModeFlg: string,
    code: string,
    srt_Order,
    obj_Cd: string,
    isDist,
  ) {
    return this.httpClientService.get(
      "/service/studio/carryFrwd/" +
        obj_Id +
        "/" +
        dxMp_Id +
        "/" +
        readModeFlg +
        "/" +
        code +
        "/" +
        srt_Order +
        "/" +
        obj_Cd +
        "/" +
        isDist,
      false,
    );
  }

  getTabData(
    fldr_Id: number,
    obj_Id: number,
    parent_Id: number,
    obj_Cd: string,
    tabCode: string,
    readModeFlg: boolean,
    res_Parent_Id: number,
    res_Obj_Cd: string,
    showBusyCursor: boolean = false,
  ) {
    //var skipCodes = ["ESM00013", "ESM00004", "ESM00167", "ESM00530"];
    return this.httpClientService.get(
      "/service/studio/getTabData/" +
        fldr_Id +
        "/" +
        obj_Id +
        "/" +
        parent_Id +
        "/" +
        obj_Cd +
        "/" +
        tabCode +
        "/" +
        readModeFlg +
        "/" +
        res_Parent_Id +
        "/" +
        res_Obj_Cd,
      true,
    );
  }

  // Data Flow

  saveInMemoryObject(
    diMsgObject: DIMsgObj,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/saveInMemoryObject",
      diMsgObject,
      showBusyCursor,
    );
  }

  validateJSON(
    obj_Cd: string,
    connFlg: boolean,
    importData: any,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/validateJSON/" + obj_Cd + "/" + connFlg,
      importData,
      showBusyCursor,
    );
  }

  getDefaultELProperties(
    conn_Id: number,
    obj_Id: number,
    dxMp_Inst_Id: number,
    dxFlow_Id: number,
    dbTyp_Id: number,
    el_Type,
    propertyType_Cd: string,
    obj_Cd: string,
    dxMp_Id: number,
    streamingFlg: string,
    dObj_Id: number,
    transObj_Cd: string,
  ) {
    return this.httpClientService.get(
      "/service/studio/getDefaultObj_Db_Properties/" +
        conn_Id +
        "/" +
        obj_Id +
        "/" +
        dxMp_Inst_Id +
        "/" +
        dxFlow_Id +
        "/" +
        dbTyp_Id +
        "/" +
        el_Type +
        "/" +
        propertyType_Cd +
        "/" +
        obj_Cd +
        "/" +
        dxMp_Id +
        "/" +
        streamingFlg +
        "/" +
        dObj_Id +
        "/" +
        transObj_Cd,
      true,
    );
  }

  getELProperties(
    dbTyp_Id: number,
    el_Type,
    conn_Id,
    dxFlow_Id,
    obj_Id,
    selectedDbTyp_Id,
  ) {
    return this.httpClientService.get(
      "/service/studio/updateFTJOptions/" +
        dbTyp_Id +
        "/" +
        el_Type +
        "/" +
        conn_Id +
        "/" +
        dxFlow_Id +
        "/" +
        obj_Id +
        "/" +
        selectedDbTyp_Id,
      true,
    );
  }

  getKafkaELProperties(
    dbTyp_Id: number,
    el_Type,
    conn_Id,
    dxFlow_Id,
    obj_Id,
    selectedDbTyp_Id,
  ) {
    return this.httpClientService.get(
      "/service/studio/updateKafkaProducerOptions/" +
        dbTyp_Id +
        "/" +
        el_Type +
        "/" +
        conn_Id +
        "/" +
        dxFlow_Id +
        "/" +
        obj_Id +
        "/" +
        selectedDbTyp_Id,
      true,
    );
  }

  getKafkaConsumerELProperties(
    dbTyp_Id: number,
    el_Type,
    conn_Id,
    dxFlow_Id,
    obj_Id,
    selectedDbTyp_Id,
  ) {
    return this.httpClientService.get(
      "/service/studio/updateKafkaConsumerOptions/" +
        dbTyp_Id +
        "/" +
        el_Type +
        "/" +
        conn_Id +
        "/" +
        dxFlow_Id +
        "/" +
        obj_Id +
        "/" +
        selectedDbTyp_Id,
      true,
    );
  }

  getGooglePubSubELProperties(
    dbTyp_Id: number,
    el_Type,
    conn_Id,
    dxFlow_Id,
    obj_Id,
    selectedDbTyp_Id,
  ) {
    return this.httpClientService.get(
      "/service/studio/updateGpsSubscriberOptions/" +
        dbTyp_Id +
        "/" +
        el_Type +
        "/" +
        conn_Id +
        "/" +
        dxFlow_Id +
        "/" +
        obj_Id +
        "/" +
        selectedDbTyp_Id,
      true,
    );
  }

  validateformula(
    validateObj: ValidateObj,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/validateformula",
      validateObj,
      true,
    );
  }

  revertPerformace(
    fldr_Id: number,
    obj_Ids: Array<number>,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    var skipCodes = ["ESM00013", "ESM00004", "ESM00167", "ESM00530"];
    return this.httpClientService.post(
      "/service/studio/revert/" + fldr_Id,
      obj_Ids,
      true,
    );
  }

  execute(
    obj_Id: number,
    runBy: string,
    diMsgObject: DIMsgObj,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/process/design/" + obj_Id + "/" + runBy,
      diMsgObject,
      showBusyCursor,
    );
  }

  layerObjectEmpty() {
    return this.httpClientService.get("/service/studio/layerobject/empty");
  }

  batchValidate(
    fldr_Id: number,
    obj_Cd: string,
    diMsgObject: DIMsgObj,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/batchvalidate/" + fldr_Id + "/" + obj_Cd,
      diMsgObject,
      showBusyCursor,
    );
  }

  interactiveonoff(
    fldr_Id: number,
    debugFlg: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/interactiveonoff/" + fldr_Id + "/" + debugFlg,
      showBusyCursor,
    );
  }

  debugoff(
    dxMp_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/debugOff/" + dxMp_Id,
      showBusyCursor,
    );
  }

  getArrangeObjects(
    object: any,
    obj_Cd: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/arrangeObjects/" + obj_Cd,
      object,
      showBusyCursor,
    );
  }

  arrangeObjectsPerformace(
    obj_Cd: string,
    obj_Id: number,
    readModeFlg: boolean,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/arrangeObjects/" +
        obj_Cd +
        "/" +
        obj_Id +
        "/" +
        readModeFlg,
      showBusyCursor,
    );
  }

  saveTransform(
    fldr_Id: number,
    obj_Cd: string,
    obj_Id: number,
    diMsgObj: DIMsgObj,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/saveTransform/" + fldr_Id + "/" + obj_Cd + "/" + obj_Id,
      diMsgObj,
      showBusyCursor,
    );
  }

  validate(
    parent_Obj_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/validate/" + parent_Obj_Id,
      showBusyCursor,
    );
  }

  updateTabData(
    design: Design,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/updateTabData",
      design,
      showBusyCursor,
    );
  }

  emptyTransformWrapper() {
    return this.httpClientService.get("/service/studio/copy/empty");
  }

  showsql(
    design: Design,
    tranform_Id: number,
    handleError: boolean,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/showsql/" + tranform_Id,
      design,
      showBusyCursor,
      handleError,
    );
  }

  showsqlPerformace(
    dxMp_Id: number,
    transform_Id: number,
    readModeFlg: boolean,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    let skipCodes = [
      "ESM00013",
      "ESM00004",
      "ESM00167",
      "ESM00530",
      "ESM00095",
      "ESM99999",
    ];
    return this.httpClientService.get(
      "/service/studio/showsql/" +
        dxMp_Id +
        "/" +
        transform_Id +
        "/" +
        readModeFlg,
      showBusyCursor,
      skipCodes,
    );
  }

  copyTransformPerformace(
    obj_Ids,
    fromDxMp_Id: number,
    toDxMp_Id: number,
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/copyTransform/" +
        fromDxMp_Id +
        "/" +
        toDxMp_Id +
        "/" +
        fldr_Id,
      obj_Ids,
      showBusyCursor,
    );
  }

  copyCommentPerformace(
    obj_Ids,
    fromDxMp_Id: number,
    toDxMp_Id: number,
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/copyComment/" +
        fromDxMp_Id +
        "/" +
        toDxMp_Id +
        "/" +
        fldr_Id,
      obj_Ids,
      showBusyCursor,
    );
  }

  interactiveModeViewData(
    parent_Id: number,
    obj_Id: number,
    runBy,
    limit,
    cmd_Cd: string,
    run_Id: number,
    readModeFlag: boolean,
    fldr_Id: number,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    let skipCodes = [
      "ESM00013",
      "ESM00004",
      "ESM00167",
      "ESM00530",
      "EFA99999",
      "EFA00010",
      "EPE00051",
      "EFA00018",
      "EFA00008",
      "EFA00022",
      "ESM99999",
      "EPE99999",
      "EFA00017",
      "EFA00016",
      "EPE00014",
      "EPE00019",
      "EFA00012",
      "EFA00027",
      "ESM00170",
    ];
    return this.httpClientService.get(
      "/service/studio/interactiveModeViewData" +
        "/" +
        parent_Id +
        "/" +
        obj_Id +
        "/" +
        runBy +
        "/" +
        limit +
        "/" +
        cmd_Cd +
        "/" +
        run_Id +
        "/" +
        readModeFlag +
        "/" +
        fldr_Id,
      showBusyCursor,
      skipCodes,
    );
  }

  getInteractiveStatus(
    fldr_Id: number,
    dxMp_Id: number,
    debugRunId: number,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.get(
      "/service/studio/getInteractiveStatus/" +
        fldr_Id +
        "/" +
        dxMp_Id +
        "/" +
        debugRunId,
      showBusyCursor,
    );
  }

  postProcessCommand(
    run_Id,
    fldr_Id,
    layer_Id,
    flow_Id,
    job_Id,
    type,
    cmd_Cd,
    debugFlg,
    diMsgObject,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/monitor/processcommand/" +
        run_Id +
        "/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        flow_Id +
        "/" +
        job_Id +
        "/" +
        type +
        "/" +
        cmd_Cd +
        "/" +
        debugFlg,
      diMsgObject,
      showBusyCursor,
    );
  }

  getSubLevelInfo(ops_poll: Ops_Poll, showBusyCursor: boolean = false) {
    return this.httpClientService.post(
      "/service/monitor/getSubLevelInfo",
      ops_poll,
      showBusyCursor,
    );
  }

  postLogObject(
    object: Ops_Poll,
    defaultLogLevel: string,
    searchText: string,
    unitName: string,
    showBusyCursor: boolean = false,
  ) {
    object.unitName = unitName;
    object.searchText = searchText;
    object.defaultLogLevel = defaultLogLevel;
    return this.httpClientService.post(
      "/service/monitor/opslog",
      object,
      showBusyCursor,
    );
  }

  postSaveLog(object) {
    return this.httpClientService.post("/service/monitor/savelog", object);
  }

  viewdata(
    numberFormatFlg: string,
    userQry: string,
    conn_Id: number,
    conn_Db_Id: number,
    dataObject: DataObject,
    fileName: string,
    fldr_Id: number,
    cleanupFlg: string,
  ): Observable<DIMsgObj> {
    let skipCodes = ["EFA00008"];

    let diMsgObject: DIMsgObj = new DIMsgObj();
    diMsgObject.refFlg = userQry;
    diMsgObject.retMsgObject = dataObject;
    diMsgObject.persistVal["fileName"] = fileName;
    diMsgObject.persistVal["cleanupFlg"] = cleanupFlg;
    return this.httpClientService.post(
      "/service/studio/viewdata/" +
        numberFormatFlg +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        fldr_Id,
      diMsgObject,
      true,
      false,
      skipCodes,
    );
  }

  gridviewdata(
    fldr_Id: number,
    dObj_Id: number,
    numberFormatFlg: string,
    diMsgObj: DIMsgObj,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/gridviewdata" +
        "/" +
        dObj_Id +
        "/" +
        fldr_Id +
        "/" +
        numberFormatFlg,
      diMsgObj,
      true,
      true,
    );
  }

  dataViewLimit(
    dxMp_Id: number,
    default_dbg_view_data_limit: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/dataViewLimit/" +
        dxMp_Id +
        "/" +
        default_dbg_view_data_limit,
      showBusyCursor,
    );
  }

  getsubobjects(
    dxMp_Id: number,
    obj_Id: number,
    tabCode: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/getsubobjects/" + dxMp_Id + "/" + obj_Id + "/" + tabCode,
      showBusyCursor,
    );
  }

  getparentsubobjects(
    dxMp_Id: number,
    obj_Id: number,
    tabCode: string,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/getparentsubobjects/" +
        dxMp_Id +
        "/" +
        obj_Id +
        "/" +
        tabCode,
      showBusyCursor,
    );
  }

  getDataMaskingStrategy(
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/getdatamaskingstrategy",
      showBusyCursor,
    );
  }

  carryFrwd(
    obj_Id: number,
    dxMp_Id: number,
    readModeFlg: string,
    code: string,
    srt_Order: number,
    obj_Cd: string,
    isDist: boolean,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.get(
      "/service/studio/carryFrwd/" +
        obj_Id +
        "/" +
        dxMp_Id +
        "/" +
        readModeFlg +
        "/" +
        code +
        "/" +
        srt_Order +
        "/" +
        obj_Cd +
        "/" +
        isDist,
      false,
    );
  }

  viewdataimport(
    conn_Id: number,
    conn_Db_Id: number,
    numberFormatFlg: string,
    isPublicSynonym: string,
    filterObject: FilterObject,
    fldr_Id: number,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/viewdataimport" +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        numberFormatFlg +
        "/" +
        isPublicSynonym +
        "/" +
        fldr_Id,
      filterObject,
      true,
      true,
    );
  }

  createMultipleInstance(
    obj_Cd: string,
    fldr_Id: number,
    layer_Id: number,
    dxmp_Id: number,
    dbTyp_Id: number,
    diMsgObject: DIMsgObj,
    showBusyCusor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/newmultisourcedmw/" +
        obj_Cd +
        "/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        dxmp_Id +
        "/" +
        dbTyp_Id,
      diMsgObject,
      showBusyCusor,
    );
  }

  newObjectForImport(
    obj_Cd: string,
    fldr_Id: number,
    layer_Id: number = -1,
    parent_Id: number,
    dbTyp_Id: number,
    dataObject: DIMsgObj,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "../../../service/studio/object/newsourcedmw/" +
        obj_Cd +
        "/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        parent_Id +
        "/" +
        dbTyp_Id,
      dataObject,
      showBusyCursor,
    );
  }

  dmwMultiPipeLines(dxMp_Id: number, multiSrcFlg: string) {
    return this.httpClientService.get(
      "/service/studio/dmwMultiPipeLines/" + dxMp_Id + "/" + multiSrcFlg,
      true,
    );
  }

  saveDmwDataObjects(diMsgObj: DIMsgObj, showBusyCursor: boolean = false) {
    return this.httpClientService.post(
      "/service/studio/object/saveDmwDataObjects",
      diMsgObj,
      showBusyCursor,
    );
  }

  saveDmwObjectPerformance(
    diMsgObj: DIMsgObj,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/saveDmwObjectPerformance",
      diMsgObj,
      showBusyCursor,
    );
  }

  dmwBulkChanges(
    selectedTransform_Id: number,
    code: string,
    diMsgObj: DIMsgObj,
  ) {
    return this.httpClientService.post(
      "../../../service/studio/dmwBulkChanges/" +
        selectedTransform_Id +
        "/" +
        code,
      diMsgObj,
      true,
    );
  }

  cleanUpFromInMemory(
    dxMp_Ids: Array<number>,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/cleanUpFromInMemory/",
      dxMp_Ids,
      showBusyCursor,
    );
  }

  createCopyAsOtherObject(
    fldr_Id: number,
    dObj_list: any,
    dbType_Id: number,
    conn_Id: number,
    conn_Db_Id: number,
    transientFlag: string,
    obj_Nm: string,
    aliasNm: string,
    showBusyCusor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/dataobject/createotherdataobjects/" +
        fldr_Id +
        "/" +
        dbType_Id +
        "/" +
        transientFlag +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        obj_Nm +
        "/" +
        aliasNm,
      dObj_list,
      showBusyCusor,
    );
  }

  getCobolConverterProperties(
    dbTyp_Id: number,
    conn_Id: number,
    dxFlow_Id: number,
  ) {
    return this.httpClientService.get(
      "/service/studio/cobolConverterJobProperties/" +
        dbTyp_Id +
        "/" +
        conn_Id +
        "/" +
        dxFlow_Id,
      true,
    );
  }

  mongoELProperties(
    dbTyp_Id,
    el_Type,
    conn_Id,
    dxFlow_Id,
    obj_Id,
    selectedDbTyp_Id,
  ) {
    return this.httpClientService.get(
      "/service/studio/updateMongoDBOptions/" +
        dbTyp_Id +
        "/" +
        el_Type +
        "/" +
        conn_Id +
        "/" +
        dxFlow_Id +
        "/" +
        obj_Id +
        "/" +
        selectedDbTyp_Id,
      true,
    );
  }

  // Parameter
  saveAdminObject(object, obj_Cd: string, handleError: boolean = false) {
    return this.httpClientService.post(
      "/service/admin/saveObject/" + obj_Cd,
      object,
      true,
      handleError,
    );
  }

  jobflowparamtemplate(dxStream_Id, flag) {
    return this.httpClientService.get(
      "/service/studio/flowparamtemplate/" + dxStream_Id + "/" + flag,
      true,
    );
  }

  // check Privilages
  checkUserPrivilege(obj_Id: number) {
    let skipCodes = ["ESM00041"];
    return this.httpClientService.get(
      "/service/studio/checkUserPrivilege/" + obj_Id,
      true,
      skipCodes,
    );
  }

  createAsTargetDP(
    parent_Id,
    selectedTransform_Id,
    conn_Id,
    conn_Db_Id,
    localFlag,
    dbTyp_Id,
    isDmwFlg,
    obj_Nm,
    objNm_Lock_Id,
    trg_Ins_Nm,
    aliasNm,
    diMsgObject: DIMsgObj,
    showBusyCursor: boolean = false,
  ) {
    //			if( transformWrapper.obj_Cd == 'SPLT' ) objNm_Lock_Id = -1;

    /**
     * trg_Ins_Nm ,obj_Nm are removed from url parameters as it not able to hit api call,if we have special characters
     */
    diMsgObject.retGridObjects[0] = obj_Nm;
    diMsgObject.retGridObjects[1] = trg_Ins_Nm;
    return this.httpClientService.post(
      "/service/studio/createAsTargetDP/" +
        parent_Id +
        "/" +
        selectedTransform_Id +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        localFlag +
        "/" +
        dbTyp_Id +
        "/" +
        isDmwFlg +
        "/" +
        objNm_Lock_Id +
        "/" +
        aliasNm,
      diMsgObject,
      showBusyCursor,
    );
  }

  createAsTstageDP(
    parent_Id,
    selectedTransform_Id,
    conn_Id,
    conn_Db_Id,
    localFlag,
    dbTyp_Id,
    showBusyCursor,
  ) {
    return this.httpClientService.get(
      "/service/studio/createAsTstageDP/" +
        parent_Id +
        "/" +
        selectedTransform_Id +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        localFlag +
        "/" +
        dbTyp_Id,
      showBusyCursor,
    );
  }

  getImportFileInfoEmpty() {
    return this.httpClientService.get("/service/studio/importfile/empty", true);
  }

  importFile(fileData: any, showBusyCursor: boolean) {
    return this.httpClientService.post(
      "/service/studio/importfile/",
      fileData,
      showBusyCursor,
    );
  }

  listfiles(listFiles: any, showBusyCursor: boolean): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/listfiles",
      listFiles,
      showBusyCursor,
    );
  }

  importTableColumns(
    conn_Id: number,
    conn_Db_Id: number,
    fldr_Id: number,
    ignoreConstraints: string,
    ignoreSynonyms: string,
    dataObjects: Array<any>,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/importTableColumns/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        fldr_Id +
        "/" +
        ignoreConstraints +
        "/" +
        ignoreSynonyms,
      dataObjects,
      showBusyCursor,
    );
  }

  downloadfile(
    downloadFile: DownloadFile,
    showBusyCursor: boolean,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/downloadfile",
      downloadFile,
      showBusyCursor,
    );
  }

  postTaskEmailListFiles(listFiles: any, showBusyCursor: boolean = true) {
    return this.httpClientService.post(
      "/service/studio/taskEmailListFiles",
      listFiles,
      showBusyCursor,
    );
  }

  getOverrideSql(
    object: any,
    performanceFlg: boolean,
    readmodeFlg: boolean,
    native_dbTypId: number,
  ) {
    return this.httpClientService.post(
      "/service/studio/getOverRideSQL/" +
        performanceFlg +
        "/" +
        readmodeFlg +
        "/" +
        native_dbTypId,
      object,
      true,
    );
  }

  getPropagateEffectedAreas(obj_Id: number, fldr_Id: number) {
    return this.httpClientService.get(
      "/service/studio/propagateeffectedareas/" + obj_Id + "/" + fldr_Id,
    );
  }

  propagateRunproperties(
    obj_Id: number,
    propertyType_Cd: string,
    obj_Db_Properties: Array<Obj_Db_Property>,
  ) {
    return this.httpClientService.post(
      "/service/studio/propagateRunproperties/" +
        obj_Id +
        "/" +
        propertyType_Cd,
      obj_Db_Properties,
    );
  }

  listAssignLayer(
    fldr_Id: number,
    obj_Cd: string,
    diMsgObj: DIMsgObj,
    showBusyCursor: boolean = false,
  ): Observable<DIMsgObj> {
    let skipCodes = ["ESM00013", "ESM00004", "ESM00167", "ESM00530"];
    return this.httpClientService.post(
      "/service/studio/assignlayer/" + fldr_Id + "/" + obj_Cd,
      diMsgObj,
      showBusyCursor,
      false,
      skipCodes,
    );
  }

  defaultDatapoint(fldr_Id, obj_Cd) {
    return this.httpClientService.post(
      "/service/defaultDatapoint/" + fldr_Id + "/" + obj_Cd,
      true,
    );
  }

  getImportDataObjects(
    conn_Id: number,
    conn_Db_Id: number,
    filterObject,
    aliasNm: string,
    ignoreSynonyms,
    showBusyCursor: boolean,
  ) {
    return this.httpClientService.post(
      "/service/studio/importTableNms/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        aliasNm +
        "/" +
        ignoreSynonyms,
      filterObject,
      showBusyCursor,
    );
    // + conn_Id + '/' + '/' + conn_Db_Id + '/' +
  }

  getWarehouses(repConn: RepConn) {
    return this.httpClientService.post(
      "/service/studio/getwarehouse",
      repConn,
      true,
      false,
      [],
      true,
    );
  }

  newDataConnectObject(
    dobjCd,
    fldr_Id,
    layer_Id,
    dbTyp_Id,
    conn_Id,
    conn_Db_Id,
    streamingFlg,
    type,
    objNm_Lock_Id,
    objCd,
    prefix,
    suffix,
    object,
    objNm,
    instObjNm,
    hiveIntegration,
    targetTableName: string = null,
    showBusyCursor,
  ) {
    if (hiveIntegration == "undefined") hiveIntegration = "FALSE";
    if (targetTableName == "") targetTableName = undefined;
    return this.httpClientService.post(
      "/service/studio/object/" +
        dobjCd +
        "/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        dbTyp_Id +
        "/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        streamingFlg +
        "/" +
        type +
        "/" +
        objNm_Lock_Id +
        "/" +
        objCd +
        "/" +
        prefix +
        "/" +
        suffix +
        "/" +
        objNm +
        "/" +
        instObjNm +
        "/" +
        hiveIntegration +
        "/" +
        targetTableName,
      object,
      showBusyCursor,
    );
  }
  createImportDataObjects(
    conn_Id,
    conn_Db_Id,
    fldr_Id,
    ignoreConstraints,
    ignoreSynonyms,
    dataObjects,
    showBusyCursor,
  ) {
    return this.httpClientService.post(
      "/service/studio/importTableColumns/" +
        conn_Id +
        "/" +
        conn_Db_Id +
        "/" +
        fldr_Id +
        "/" +
        ignoreConstraints +
        "/" +
        ignoreSynonyms,
      dataObjects,
      showBusyCursor,
    );
  }
  newDataConnectDesign(
    fldr_Id,
    object: DIMsgObj,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/newDataConnectDesign/" + fldr_Id,
      object,
      showBusyCursor,
    );
  }

  getExpressionEditorFunction(dbTyp_Id: number, obj_Cd: string) {
    return this.httpClientService.get(
      "/service/studio/functions/" + dbTyp_Id + "/" + obj_Cd,
    );
  }

  dataCleanseApplyToAll(
    diMsgObj: DIMsgObj,
    replaceFlg: string,
    dbTyp_Id: number = -1,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/applyDatacleanseFunctions/" +
        dbTyp_Id +
        "/" +
        replaceFlg,
      diMsgObj,
      showBusyCursor,
    );
  }

  newmultisourcegoogleanalytics(
    obj_Cd: string,
    fldr_Id: number,
    layer_Id: number,
    dxmp_Id: number,
    dbTyp_Id: number,
    diMsgObjectEmpty: DIMsgObj,
  ) {
    return this.httpClientService.post(
      "/service/studio/newmultisourcegoogleanalytics/" +
        obj_Cd +
        "/" +
        fldr_Id +
        "/" +
        layer_Id +
        "/" +
        dxmp_Id +
        "/" +
        dbTyp_Id,
      diMsgObjectEmpty,
      true,
    );
  }

  getRestOperations(
    objDbProperties: Array<Obj_Db_Property>,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/getrestoperations",
      objDbProperties,
      showBusyCursor,
    );
  }

  getInputParameters(
    fldr_Id: number,
    obj_Id: number,
    objDbProperties: Array<Obj_Db_Property>,
    showBusyCursor: boolean = false,
  ) {
    return this.httpClientService.post(
      "/service/studio/getrestinputparameters/" + fldr_Id + "/" + obj_Id,
      objDbProperties,
      showBusyCursor,
    );
  }

  getDmwMode() {
    return this.httpClientService.get("/service/studio/getDmwMode", true);
  }

  dmwReplaceAction(fldr_Id: number, login_Id: number, design: Design) {
    return this.httpClientService.post(
      "/service/studio/dmwrepalceaction" + "/" + fldr_Id + "/" + login_Id,
      design,
      true,
    );
  }

  monitorUnSubscribe(obj_Id: number) {
    // return this.httpClientService.get('/service/monitor/poll/unsubscribe/' + userId);
    return this.httpClientService.get(
      "/service/monitor/poll/unsubscribe/canvas/monitor/" + obj_Id,
    );
  }

  getStreamLevelInfo(
    fldr_Id: number,
    showBusyCursor: boolean = false,
    level1_Id: number,
    instanceNm: string,
  ): Observable<DIMsgObj> {
    let n = new Date().getTimezoneOffset() * 60;
    let skipCodes = ["ESM00041"];
    let diMsgObject: DIMsgObj = new DIMsgObj();

    diMsgObject.retMsgObject = instanceNm;
    return this.httpClientService.post(
      "/service/monitor/getStreamLevelInfo/" +
        fldr_Id +
        "/" +
        n +
        "/" +
        level1_Id,
      diMsgObject,
      true,
      true,
      skipCodes,
      showBusyCursor,
    );
  }

  selectPartitionProperties(obj_Id: number) {
    return this.httpClientService.get(
      "/service/studio/selectPartitionProperties/" + obj_Id,
      true,
    );
  }

  /* getStreamingPlatformList method
   */
  getStreamingPlatformList(
    fldr_Id: number,
    obj_Cd: string,
    operation_Cd: string,
  ): Observable<DIMsgObj> {
    return this.httpClientService.post(
      "/service/studio/streaminglist/" +
        fldr_Id +
        "/" +
        obj_Cd +
        "/" +
        operation_Cd,
      [],
    );
  }

  getCatalogUrl(obj: string) {
    return this.httpClientService.get("/service/studio/config/url/" + obj);
  }

  /**
   * Catalog sync state for one Data Point. Catalog sync is fail-soft and silent, so without this
   * a user has no way to tell whether their connection reached the catalog.
   * A null retMsgObject means it has never been synced, which is a normal state.
   */
  getCatalogSyncStatus(connId: number) {
    return this.httpClientService.get("/service/studio/catalog/sync/status/" + connId);
  }


  generateAIMapping(dxMp_Id: number, showBusyCursor: boolean = false) {
    return this.httpClientService.get(
      "/service/studio/attributemappingschema/" + dxMp_Id,
      showBusyCursor,
    );
  }

  authorizeUser(): Observable<DIMsgObj> {
    return this.http.get<DIMsgObj>("/service/oidc/authorize", {
      withCredentials: true,
    });
  }
}

